export default "__VITE_ASSET__Dmf_yAMk__"